<template>
  <div class="tw-p-4 tw-rounded-32 tw-border-t-2 tw-border-app-white-87 tw-h-full tw-shadow-none">
    <div class="tw-h-full">
      <div class="tw-inline-flex tw-flex-no-wrap tw-items-center tw-mb-2">
        <UserPhoto
          :photo="selectedTicket.sender.photo"
          :user-name="{
            name: selectedTicket.sender.name,
          }"
          photo-size="tw-h-6 tw-w-6"
        />
        <div class="tw-ml-2">
          <p class="tw-text-sm opacity-87 tw-inline-flex tw-gap-2">
            <span>
              {{ selectedTicket.sender.name }} {{ selectedTicket.sender.middle || selectedTicket.sender.last_name }}
            </span>
            <span>
              &#x00B7;
            </span>
            <span>
              <a :href="`mailto:${selectedTicket.sender.email}`" target="_blank" class="tw-underline">
                {{ selectedTicket.sender.email }}
              </a>
            </span>
            <!-- <span>
              <a :href="`tel:${selectedTicket.sender.phoneNumber}`" target="_blank" class="tw-text-app-deep-blue tw-underline">
                {{ selectedTicket.sender.phoneNumber }}
              </a>
            </span> -->
          </p>
          <p class="tw-text-sm opacity-54">
            {{ selectedTicket.tym | toJsDate(true) | moment('ddd Do hh:mm A') }}
          </p>
        </div>
      </div>
      <p class="tw-text-xl tw-font-bold tw-mb-2">
        {{ selectedTicket.chat_message }}
      </p>
      <!-- Ticket Resolution -->
      <template v-if="ticketIsResolved">
        <div class="tw-h-full">
          <div class="tw-rounded-32 tw-px-2 tw-py-1 tw-bg-app-deep-blue tw-text-white tw-text-sm tw-font-bold tw-mb-2 tw-inline-block">
            Resolved by {{ selectedTicket.resolvedBy?.name }}
          </div>

          <p class="tw-text-lg tw-p-2 tw-rounded-10 tw-bg-gray-100" v-html="selectedTicket.resolved"></p>
          <p class="tw-text-sm opacity-54 tw-px-2">
            {{ selectedTicket.end_tym | toJsDate(true) | moment('ddd Do hh:mm A') }}
          </p>
        </div>
      </template>

      <!-- Resolve Ticket -->
      <template v-else>
        <div class="">
          <label class="tw-text-xs tw-text-black opacity-78">
            Resolution: Please provide a detailed resolution to the ticket. <br />
            This will be sent to the user ({{ selectedTicket.sender.name }}) as a notification.
          </label>
          <QuillTextareaGroup
            :rows="3"
            class="tw-bg-white"
            v-model="ticketResolution"
            max-height="400px"
          />
          <BaseButton
            @click="resolveTicket"
            :text="ticketResolutionLoading ? 'Resolving...' : 'Resolve Ticket'"
            :disabled="ticketResolutionLoading"
            class="tw-bg-black tw-border-0 tw-text-white"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import UserPhoto from '@/components/UserPhoto.vue';
import QuillTextareaGroup from '@/components/QuillTextareaGroup.vue';

export default {
  name: 'SupportTicket',
  components: {
    UserPhoto,
    QuillTextareaGroup,
  },
  props: {
    ticket: {
      type: Object,
      required: true,
    },
    adminId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      ticketId: this.$route.params.ticketId,
      selectedTicket: this.ticket,
      ticketResolution: '',
      ticketResolutionLoading: false,
      openAdminId: this.$route.params.adminId,
    };
  },
  watch: {
    ticket: {
      handler(newVal) {
        this.selectedTicket = newVal;
      },
      deep: true,
    },
  },
  computed: {
    ticketIsResolved() {
      // eslint-disable-next-line eqeqeq
      return this.selectedTicket?.prog_status == 1;
    },
  },
  methods: {
    async resolveTicket() {
      if (!this.ticketResolution) {
        this.$toasted.global.appError({
          errorMessage: 'Please provide a resolution',
        });
        return;
      }

      this.ticketResolutionLoading = true;
      await this.$store.dispatch('resolveTicket', {
        ticketid: this.ticket.id,
        solution: this.ticketResolution,
        adminid: this.openAdminId,
      });

      this.$emit('ticket-resolved');

      // update the selected ticket with it's resolution
      this.selectedTicket = {
        ...this.ticket,
        prog_status: 1,
        resolved: this.ticketResolution,
        end_tym: new Date().toISOString(),
        resolvedBy: {
          name: 'you',
        },
      };

      this.ticketResolution = '';

      this.ticketResolutionLoading = false;
    },
  },
};
</script>

<style>

</style>
